import script from "./QiZhengSiYu.vue?vue&type=script&setup=true&lang=js"
export * from "./QiZhengSiYu.vue?vue&type=script&setup=true&lang=js"

import "./QiZhengSiYu.vue?vue&type=style&index=0&id=e2c02a7a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e2c02a7a"]])

export default __exports__